import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";

const socialLinksConfig = [
  { key: "facebook", icon: <FaFacebook /> },
  { key: "instagram", icon: <FaInstagram /> },
  { key: "linkedin", icon: <FaLinkedin /> },
  { key: "youtube", icon: <FaYoutube /> },
  { key: "xurl", icon: <FaTwitter /> },
];

function SocialLinks({ socialMedia = {} }) {
  const hasAnySocial = Object.values(socialMedia || {}).some((val) => val);

  return (
    <>
      {hasAnySocial
        ? // 🔥 Show only available links
          socialLinksConfig.map(
            (item) =>
              socialMedia[item.key] && (
                <a
                  key={item.key}
                  href={socialMedia[item.key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link footer-social-btn"
                  aria-label={item.key}
                >
                  {item.icon}
                </a>
              ),
          )
        : // 🔥 Show all default icons
          socialLinksConfig.map((item) => (
            <a key={item.key} href="#" className="social-link">
              {item.icon}
            </a>
          ))}
    </>
  );
}

export default SocialLinks;
